export default "__VITE_ASSET__Biowccnd__"